import { SearchPageHit, SearchPageHits } from '../../../graphql/__generated__/types/contento';

export const stripEms = (data: string): string => data.replace(/(<em>|<\/em>)/g, '');

export const value = (item: SearchPageHit): string => {
    if (item.categoryTeaser) {
        return `${stripEms(item.categoryTeaser.heading)} (kategori)`;
    }

    if (item.teaser?.subHeading) {
        return `${stripEms(item.teaser.heading)}: ${stripEms(item.teaser.subHeading)}`;
    }

    return `${stripEms(item.teaser.heading)}`;
};

export const getUrl = (item: SearchPageHit): string => {
    if (item.teaser?.item.urls?.svtplay) {
        return item.teaser.item.urls.svtplay;
    }

    if (item.categoryTeaser) {
        return ['teckensprak', 'syntolkat'].includes(item.categoryTeaser.id)
            ? `/${item.categoryTeaser.id}`
            : `/kategori/${item.categoryTeaser.id}`;
    }

    return '/sida-saknas';
};

export const sortSearchResult = (result): SearchPageHits => {
    if (result?.hits) {
        result.hits.sort((item) => {
            switch (item.categoryTeaser?.id) {
                case 'teckensprak':
                case 'tydligare-tal':
                case 'upplast-undertext':
                case 'syntolkat':
                    return -1;
                default:
                    return 0;
            }
        });
    }

    return result;
};

export const getId = (item: SearchPageHit): string => {
    if (item.categoryTeaser) {
        return `${item.categoryTeaser.id}`;
    }

    if (item.teaser?.item) {
        return `${item.teaser.item.svtId}`;
    }

    return '';
};

export const getContentId = (item: SearchPageHit): string => {
    if (item.categoryTeaser) {
        return `${stripEms(item.categoryTeaser.heading)}`;
    }

    if (item.teaser?.item) {
        return `${item.teaser.item.svtId}`;
    }

    return '';
};
